import React, { useEffect } from "react";
import SidebarSetting from "../../component/SidebarSetting/SidebarSetting";
import Navbar from "../../component/Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteWaiter,
  getWaiters,
  selectWaiters,
} from "../../redux/features/waiter/WaiterSlice";
import waiterLogo from "../../Asset/waiter logo.png";
import waiterImage from "../../Asset/waiter image.png";
import CreateUpdateWaiter from "./createUpdateWaiter";
import { MdDelete } from "react-icons/md";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
const Waiter = () => {
  const waiters = useSelector(selectWaiters);
  const dispatch = useDispatch();

  const confirmDelete = (id, name) => {
    if (!id || !name) {
      toast.error("ID or Name is undefined");
      return;
    }
    confirmAlert({
      title: "Delete this waiter",
      message: `Are you sure to delete the ${name}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeWaiter(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };
  const removeWaiter = async (waiterId) => {
    await dispatch(deleteWaiter(waiterId));
    dispatch(getWaiters());
  };
  useEffect(() => {
    dispatch(getWaiters());
  }, [dispatch]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      <div>
        <Navbar page="Settings" />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="lg:w-[30%] md:w-[39%] w-[35%] bg-white shadow-md">
          <SidebarSetting />
        </div>

        {/* Main Content */}
        <div className="flex-1 md:p-8 py-6 px-4 relative overflow-y-auto scrollbar-hide">
          {waiters ? (
            <div className="mx-auto">
              <div className="flex  justify-start  gap-4 w-full flex-wrap">
                {waiters.map((waiter, i) => (
                  <div
                    key={i}
                    className="md:w-[9rem] w-[7rem] md:h-[9rem] h-[7rem] bg-slate-300 rounded-2xl overflow-hidden flex items-center justify-center relative"
                  >
                    <img
                      src={waiterImage}
                      alt={`waiter`}
                      className="w-full h-full object-cover"
                    />
                    <p className="absolute bg-[#20BEC6CC] w-full text-center md:text-[14px] text-[12px] md:bottom-8 bottom-6 font-semibold text-white py-1 capitalize">
                      {waiter.waiterName}
                    </p>
                    <button
                      onClick={() =>
                        confirmDelete(waiter._id, waiter.waiterName)
                      }
                      className="absolute text-white bg-[#fa3426cc] rounded-lg p-[4px] top-2 left-2"
                    >
                      <MdDelete className="size-4" />
                    </button>
                    <CreateUpdateWaiter waiter={waiter} />
                  </div>
                ))}
              </div>
              <CreateUpdateWaiter />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[29rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <img
                  src={waiterLogo}
                  className="size-16 md:size-32 mb-2"
                  alt="Logo"
                />
                <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                  You have no waiter yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a waiter, press the (+) button
                </p>
                {/* <CreateCateyory /> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Waiter;
